import { render } from "./AntragstellerWizardAccess.pug?vue&type=template&id=c5b61b38&lang=pug"
import script from "./AntragstellerWizardAccess.js?vue&type=script&lang=js"
export * from "./AntragstellerWizardAccess.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__